var React = require('react');

function CaretUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.6603 -7.57103e-07L4.57764e-05 10L17.3206 10L8.6603 -7.57103e-07Z"}));
}

CaretUpInline.defaultProps = {"width":"18","height":"10","viewBox":"0 0 18 10"};

module.exports = CaretUpInline;

CaretUpInline.default = CaretUpInline;
